// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'

// On Project Summary and on Bulk Edits, the user can filter the displayed paths
// based on various criteria. This function determines if a path matches should
// be displayed based on a filter text and select category.

// NOTE - band is not applicable when calling this in the context of Bulk Edits
// since Band is separated into its own filter radio group.

const pathContainsSubstring = (path, selectValue, inputValue) => {
  const formattedInputValue = inputValue.toLowerCase().trim()

  // looks to see if inputValue is a substring of v
  const hasInputSubString = v => (
    castToString(v).toLowerCase().includes(formattedInputValue)
  )

  // checks the path ends to see if either of them can match the substring.
  const pathEndHasSubstring = p => (
    hasInputSubString(path.getIn(['site1', ...p])) ||
    hasInputSubString(path.getIn(['site2', ...p]))
  )

  switch (selectValue) {
    case 'antennaCode' :
      return pathEndHasSubstring(['antennas', 'primary', 'antennaCode'])

    case 'antennaModel' :
      return pathEndHasSubstring(['antennas', 'primary', 'modelNumber'])

    case 'band' :
      return hasInputSubString(path.get('band'))

    case 'callSign' :
      return pathEndHasSubstring(['callSign'])

    case 'maxPower' :
      return pathEndHasSubstring(['radio', 'maxPower'])

    case 'pathName' :
      return hasInputSubString(path.get('pathName'))

    case 'radioBandwidth' :
      return pathEndHasSubstring(['bandwidth'])

    case 'radioCode' :
      return pathEndHasSubstring(['radio', 'radioCode'])

    case 'siteName' :
      return pathEndHasSubstring(['siteName'])

    case 'segmentStatus' :
      return pathEndHasSubstring(['segmentStatus'])

    default :
      throw new Error('pathContainsSubstring error: unmapped selectValue of ' + selectValue)
  }
}

export default pathContainsSubstring
